import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Locale } from '@rct/lynx-lobbies-shared-lib';
import { BehaviorSubject, Observable } from 'rxjs';

declare global {
  interface Window {
    electronAPI: {
      getElectronSystemLocale: () => Locale | undefined;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class LynxElectronService {
  private _electronWrapperSystemLocaleSubject: BehaviorSubject<
    Locale | undefined
  > = new BehaviorSubject<Locale | undefined>(undefined);

  private _electronWrapperSystemLocale$ =
    this._electronWrapperSystemLocaleSubject.asObservable();

  private _isElectron: boolean = false;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    if (
      isPlatformBrowser(platformId) &&
      window &&
      !!window.electronAPI &&
      !!window.electronAPI.getElectronSystemLocale
    ) {
      this._isElectron = true;
      this.loadElectronWrapperSystemLocale();
    }
  }

  loadElectronWrapperSystemLocale(): void {
    if (this._isElectron) {
      this._electronWrapperSystemLocaleSubject.next(
        window.electronAPI.getElectronSystemLocale()
      );
    }
  }

  getElectronWrapperSystemLocale$(): Observable<Locale | undefined> {
    return this._electronWrapperSystemLocale$;
  }
}
